import { render, staticRenderFns } from "./PricingCardStyle1.vue?vue&type=template&id=5c0e29e7"
import script from "./PricingCardStyle1.vue?vue&type=script&lang=js"
export * from "./PricingCardStyle1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports